<template>
  <!-- 面包屑 -->
  <a-breadcrumb>
    <a-breadcrumb-item>推广管理</a-breadcrumb-item>
    <a-breadcrumb-item>推广链接</a-breadcrumb-item>
  </a-breadcrumb>
  <!-- 功能条 -->
  <div class="tool-view">
    <a-row class="tool-row">
      <a-col :span="6">
        <a-row>
          <!-- 日期： -->
          <a-col :span="6" class="tool-title">日期：</a-col>
          <a-col :span="18">
            <a-range-picker 
              v-model:value="dateRange" 
              class="tool-item"
              format="YYYY-MM-DD"
              :placeholder="['开始日期', '结束日期']"
            />
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="6">
        <a-row>
          <!-- 服务商： -->
          <a-col :span="6" class="tool-title">服务商：</a-col>
          <a-col :span="18">
            <a-input v-model:value="serviceProviderModel" class="tool-item" placeholder="请输入名称" />
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="6">
        <a-row>
          <!-- 操作 -->
          <a-col :span="6" class="tool-title"></a-col>
          <a-col :span="18" style="white-space: nowrap;">
            <a-button type="primary" @click="touchSearch">查询</a-button>
            <a-button style="margin-left: 16px" @click="touchReset">重置</a-button>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="6" style="text-align: right;">
        <a-button type="primary" @click="touchAdd">+ 新建链接</a-button>
      </a-col>
    </a-row>
  </div>
  <!-- 列表 -->
  <a-table
    class="table-view"
    :data-source="dataSource"
    :columns="columns"
    :row-key="record => record.id"
    :pagination="pagination"
    :loading="isLoading"
    @change="handleTableChange"
  >
    <!-- 自定义行内容 -->
    <template #bodyCell="{ column, record }">
      <!-- 跳转类型 -->
      <template v-if="column.key === 'page_where'">
        {{ LandingTypes.find(item => item.value === record[column.key]).text || '-' }}
      </template>
      <!-- 短剧名称 -->
      <template v-else-if="column.key === 'drama_name'">
        <a-tooltip :title="record.lang_drama_name" placement="top">
          <span>{{ record[column.key] || '-' }}</span>
        </a-tooltip>
      </template>
      <!-- 创建时间 -->
      <template v-else-if="column.key === 'created_time'">
        <a-tooltip :title="getFullDateTime(record[column.key])" placement="top">
          <span>{{ getShortDate(record[column.key]) }}</span>
        </a-tooltip>
      </template>
      <!-- 推广渠道 -->
      <template v-else-if="column.key === 'channel'">
        {{ PromotionLinkChannels.find(item => item.value === record[column.key])?.text || '-' }}
      </template>
      <!-- 操作 -->
      <template v-else-if="column.key === 'operation'">
        <a class="operation-item" @click="touchEdit(record)">编辑</a>
        <a class="operation-item" @click="touchCopyLink(record)">复制链接</a>
      </template>
      <template v-else>
        {{ record[column.key] || '-' }}
      </template>
    </template>
  </a-table>
  <!-- 新建/编辑推广链接 -->
  <PromotionLinkAdd ref="RefPromotionLinkAdd" @success="touchSearch"></PromotionLinkAdd>
</template>

<script setup>
import { onBeforeMount, reactive, ref } from 'vue'
import { message } from 'ant-design-vue'
import { LandingTypes, PromotionLinkChannels } from '@/utils/constantList'
// 引入 dayjs 及 扩展函数
import dayjs from 'dayjs'
// 引入公共方法
import Pub from '@/utils/public'
// 引入 API
import { popularizeList } from '@/api/admin'
import PromotionLinkAdd from './components/PromotionLinkAdd.vue'

let RefPromotionLinkAdd = ref(null)

// 日期范围
let dateRange = ref([dayjs().subtract(30, 'day'), dayjs()])
// 服务商名称
let serviceProvider = ref(undefined)
let serviceProviderModel = ref(undefined)
// 加载
let isLoading = ref(false)
// 数据源
let dataSource = ref([])
// 分页信息
let pagination = reactive({
  total: 0,
  current: 1,
  pageSize: 10,
  showSizeChanger: true
})
// 列数据源
let columns = ref([
  {
    title: '推广ID',
    dataIndex: 'id',
    key: 'id'
  },
  {
    title: '口令码',
    dataIndex: 'code',
    key: 'code'
  },
  {
    title: '推广链接名称',
    dataIndex: 'name',
    key: 'name'
  },
  {
    title: '跳转类型',
    dataIndex: 'page_where',
    key: 'page_where'
  },
  {
    title: '短剧名称',
    dataIndex: 'drama_name',
    key: 'drama_name'
  },
  {
    title: '界面语种',
    dataIndex: 'lang_name',
    key: 'lang_name'
  },
  {
    title: '跳转集数',
    dataIndex: 'eq_number',
    key: 'eq_number'
  },
  {
    title: '创建时间',
    dataIndex: 'created_time',
    key: 'created_time'
  },
  {
    title: '服务商名称',
    dataIndex: 'reseller_name',
    key: 'reseller_name'
  },
  {
    title: 'AD识别码',
    dataIndex: 'adj_id',
    key: 'adj_id'
  },
  {
    title: 'AD短链识别码',
    dataIndex: 'adj_linkid',
    key: 'adj_linkid'
  },
  {
    title: '推广渠道',
    dataIndex: 'channel',
    key: 'channel'
  },
  {
    title: '操作',
    dataIndex: 'operation',
    key: 'operation'
  }
])

onBeforeMount (() => {
  // 初始化获取
  touchSearch()
})

// 模糊匹配
function filterOption (input, option) {
  return `${option.key}`.toLowerCase().includes(`${input || ''}`.toLowerCase())
}

// 分页处理
function handleTableChange (p, filters, sorter) {
  pagination.current = p.current
  pagination.pageSize = p.pageSize
  // 获取列表
  getPromotionLinkList()
}

// 查询
function touchSearch () {
  // 调整参数
  serviceProvider.value = serviceProviderModel.value
  pagination.current = 1
  // 获取列表
  getPromotionLinkList()
}

// 重置
function touchReset () {
  serviceProviderModel.value = undefined
  serviceProvider.value = undefined
  dateRange.value = [dayjs().subtract(30, 'day'), dayjs()]
  // 初始化获取
  touchSearch()
}

// 获取短日期格式 (YYYY-MM-DD)
function getShortDate (dateTime) {
  if (!dateTime) return '-'
  return dayjs(dateTime).format('YYYY-MM-DD')
}

// 获取完整日期时间格式 (YYYY-MM-DD HH:mm:ss)
function getFullDateTime (dateTime) {
  if (!dateTime) return '-'
  return dayjs(dateTime).format('YYYY-MM-DD HH:mm:ss')
}

// 复制链接
function touchCopyLink (record) {
  // 复制百度地址
  if (Pub.IS_DEBUG()) {
    Pub.COPY(`https://test-land.gooddrama.cc/?link_adjid=${record.adj_linkid || ''}&link_adjtoken=${record.adj_id || ''}&link_id=${record.id || ''}&debug=1&openlog=1`)
  } else {
    Pub.COPY(`https://land.gooddrama.cc/?link_adjid=${record.adj_linkid || ''}&link_adjtoken=${record.adj_id || ''}&link_id=${record.id || ''}`)
  }
}

// 新建推广链接
function touchAdd () {
  RefPromotionLinkAdd.value.showDrawer()
}

// 编辑推广链接
function touchEdit (record) {
  RefPromotionLinkAdd.value.showDrawer(record)
}

// 获取列表
function getPromotionLinkList () {
  isLoading.value = true
  const params = {
    name: serviceProvider.value,
    start_time: dateRange.value && dateRange.value[0] ? dateRange.value[0].format('YYYY-MM-DD') : undefined,
    end_time: dateRange.value && dateRange.value[1] ? dateRange.value[1].format('YYYY-MM-DD') : undefined,
    page: pagination.current,
    page_size: pagination.pageSize
  }
  // TODO: 替换为实际的API调用
  popularizeList(params).then(res => {
    isLoading.value = false
    const { code, data } = res
    if (code === 0) {
      dataSource.value = data.data
      pagination.total = data.total
    }
  }).catch(() => {
    isLoading.value = false
  })
}
</script>

<style scoped>

.tool-row {
  margin-bottom: 16px;
}

.tool-title {
  text-align: right;
}

.tool-item {
  width: 100%;
}

.table-view {
  background: #fff;
  border-radius: 6px;
}

.link-text {
  color: #1890ff;
  text-decoration: none;
  word-break: break-all;
}

.link-text:hover {
  text-decoration: underline;
}
</style>
